export default "__VITE_ASSET__DqG0BnLh__"